import { useCallback } from "react";
import { StringRecord } from "../utils/storageValidation";
import { useDeviceProgress } from "./useDeviceProgress";

export type BlogReadProgress = StringRecord<string>;

const FEATURE_KEY = "blogReadProgress";

// Mirrors useLessonProgress/useGrammarProgress's device-progress pattern: one
// row per signed-in user, keyed by each post's stable slug (the same slug
// used for both /blog/<slug> and its /pt/blog/<slug> translation - see
// consts/blogPosts.ts), valued "read". Unlike "learned" flags elsewhere,
// there is no undo affordance here - BlogPostPage sets this once a reader's
// active time on the post crosses its estimated reading time, and it stays
// set.
export function useBlogReadProgress() {
    const { data: progress, update, syncStatus } = useDeviceProgress<BlogReadProgress>(FEATURE_KEY);
    const setRead = useCallback((slug: string) => update({ kind: "set", key: slug, value: "read" }), [update]);
    return { progress, setRead, syncStatus };
}
